import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
/* shows application status and assignment log history */
export class HistoryComponent implements OnInit {

  @Input() historyLog: Array<any>;
  @Output() toggle = new EventEmitter<boolean>();
  public showLogHistory : boolean = false;
  
  constructor(public utilService: UtilsService) { }

  ngOnInit(): void {
  }

  toggleHistory() {
    this.showLogHistory = !this.showLogHistory;
    if (this.showLogHistory) {
      this.toggle.emit(true);
    }
  }

  /** Same status with a comment — e.g. Pay now clicked without status change. */
  isActivityLog(history: any): boolean {
    if (!history?.comment || history.isAssignmentLog) {
      return false;
    }
    if (history.oldName && history.newName) {
      return history.oldName === history.newName;
    }
    if (history.oldCode && history.newCode) {
      return history.oldCode === history.newCode;
    }
    return history.oldValue != null && history.oldValue === history.newValue;
  }
}
